module.exports = __webpack_public_path__ + "static/img/btn_close_popmo_popup.c9bbfc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/btn_close_popmo_popup.svg
// module id = 84CV
// module chunks = 10